// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./CheckBox";
export type { CheckBoxProps } from "./CheckBox";
